export default __webpack_public_path__ + "static/media/illustration.41d976a2.svg";